import { OutboxResponse } from '../interface';

export class OutboxModel implements OutboxResponse {
    threadId: string;
    message: string;
    timestamp: string;
    orgMemberId: string;
    contactId: string;
    dateCreated: string;
    status: any;
    error: any;
    firstName: string;
    lastName: string;
    company: string;
    organizationId: string;
    id: string;
    name: string;
    campaignName: string;
    campaignId: string;

    constructor(message: OutboxResponse) {
        this.id = message.id;
        this.dateCreated = message.dateCreated;
        this.orgMemberId = message.orgMemberId;
        this.contactId = message.contactId;
        this.timestamp = message.timestamp;
        this.threadId = message.threadId;
        this.message = message.message;
        this.error = message.error;
        this.status = message.status;
        this.firstName = message.firstName;
        this.name = `${message.firstName} ${message.lastName}`;
        this.lastName = message.lastName;
        this.company = message.company;
        this.organizationId = message.organizationId;
        this.campaignName = message.campaignName;
        this.campaignId = message.campaignId;
    }
}
